// initial state
const state = () => ({
    cart: {},
});

// getters
const getters = {};
// actions
const actions = {
    getCart({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/api/customer/cart").then(
                (response) => {
                    commit("saveCart", response.data);

                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    refreshCart({ dispatch, commit }) {
        return new Promise((resolve, reject) => {
            dispatch("getCart").then(() => {
                resolve();
            });
        });
    },
};
// mutations
const mutations = {
    saveCart(state, cart) {
        state.cart = cart;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
